module.exports = __webpack_public_path__ + "img/miss-kim-knows-and-other-stories.f442cac4.png";